export default __webpack_public_path__ + "static/summer_containers94-e284f0a9a869023ad0ff74c43531d963.webp";